/*
 * Menu promo photos live in the closed mega menu and mobile drawer. Those are laid out but hidden,
 * so `loading="lazy"` alone still fetches them on every page. The images hold their URLs in
 * data-src / data-srcset until the visitor reaches for the header (hover, focus or touch), which
 * is before any menu can open.
 */

const SELECTOR = 'img[data-ari-menu-promo]';
const HEADER = '#header-component';

function release() {
  for (const image of document.querySelectorAll(SELECTOR)) {
    if (image.dataset.srcset) image.srcset = image.dataset.srcset;
    if (image.dataset.src) image.src = image.dataset.src;
    image.removeAttribute('data-srcset');
    image.removeAttribute('data-src');
    image.removeAttribute('data-ari-menu-promo');
  }
}

/** @param {Event} event */
function onIntent(event) {
  if (event.target instanceof Element && event.target.closest(HEADER)) release();
}

// Kept for the whole visit, so a header re-rendered later still gets its images
for (const type of ['pointerover', 'focusin', 'touchstart']) {
  document.addEventListener(type, onIntent, { passive: true });
}

// The theme editor shows the menu without hovering
if (window.Shopify?.designMode) release();
document.addEventListener('shopify:section:load', release);
